import { IUseTrainingPlansProgressReturn, useTrainingPlansProgress } from "@hooks/game/training-plans/use-training-plans-progress";
import { createContext, ReactNode, useContext } from "react";

const TrainingPlansProgressContext = createContext<IUseTrainingPlansProgressReturn | undefined>(undefined);

interface ITrainingPlansProgressProviderProps {
  children: ReactNode;
}

export const TrainingPlansProgressProvider = ({ children }: ITrainingPlansProgressProviderProps) => {
  const value = useTrainingPlansProgress();

  return <TrainingPlansProgressContext.Provider value={value}>{children}</TrainingPlansProgressContext.Provider>;
};

export const useTrainingPlansProgressContext = () => {
  const context = useContext(TrainingPlansProgressContext);

  if (!context) {
    throw new Error("useTrainingPlansProgressContext must be used within TrainingPlansProgressProvider");
  }

  return context;
};
